/**
 * Entity type constants used throughout the application
 *
 * These constants define the different types of entities that can be
 * pinned, tagged, or have gradients applied to them.
 */
export const ENTITY_TYPES = {
  TEAM: /** @type {"team"} */ ("team"), // Used in pinned entities and gradient systems
  GROUP: /** @type {"group"} */ ("group"), // Used in tag/allocation systems (alias for teams)
  PERSON: /** @type {"person"} */ ("person"),
  TAG: /** @type {"tag"} */ ("tag"),
  AGENT: /** @type {"agent"} */ ("agent"),
};
